
  

  // Retrieve user details from localStorage
  export function getUserContext(): any {
    const userContext = {
      username: localStorage.getItem('user'),
      name: localStorage.getItem('name'),
      role: localStorage.getItem('role'),
      branch: localStorage.getItem('branch')
    };
return userContext;

  }

  